import { render } from "./SubjectBookImage.vue?vue&type=template&id=22196a03&scoped=true"
import script from "./SubjectBookImage.vue?vue&type=script&lang=js"
export * from "./SubjectBookImage.vue?vue&type=script&lang=js"

import "./SubjectBookImage.vue?vue&type=style&index=0&id=22196a03&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22196a03"]])

export default __exports__